import {
    formatQueryParams,
    stripItmFromQueryParameters,
    toQueryParameters
} from 'tradera/utils/url';
import cookieUtil from 'tradera/utils/cookie';

import { setTcfLoaded } from './ads/actions';
import { fetchSystemMessages, fetchSystemBadges } from './ui/actions';
import * as pushNotificationActions from './push-notifications/push-notifications-slice';
import { initializeFromInitData as initShippingRegion } from './shipping-region/actions';
import * as discoverActions from './discover/actions';
import { initEnvironment } from './environment/actions';
import { initialize as initLanguage } from './language/reducer';
import { initializeFromInitData as initMember } from './member/reducer';
import { initialize as initInitData } from './init-data/actions';
import {
    defaultCurrency,
    initialize as initMultiCurrency
} from './multi-currency/reducer';
import { initialize as initPersonalisation } from './personalisation/reducer';
import { initialize as initializeItems } from './items/reducer';
import { initialize as initializePage } from './page/reducer';

// Views
import { handleReportItemModel } from './views/report-item/actions';
import { initialize as initStartPage } from './views/start-page/reducer';
import { initializeFromInitData as initializeUiFromInitData } from './ui/initial-state';
import { receiveSearchResults } from './discover/reducer';
import { handleTraderaShopProduct } from './views/tradera-shop/actions';
import { setRandomNumber } from './random/reducer';
import type { AppDispatch } from 'tradera/state/configure-store';
import type { InitData } from 'tradera/state/init-data/types';
import { initKountSessionId } from 'tradera/apps/login/state/actions';
import { RECENT_SEARCHES } from 'tradera/constants/cookies';
import { setMessages as setOutageMessages } from 'tradera/state/outage/reducer';

export const initializeState =
    (initData: InitData) => (dispatch: AppDispatch) => {
        const { isLoggedIn, featureSwitches, currencies, currencyCode } =
            initData;

        const preferredCurrency = isLoggedIn
            ? currencyCode
            : cookieUtil.readCookie('preferred_currency') ||
              defaultCurrency.code;
        /**
         * handle tcf + gdpr loading
         */
        if (featureSwitches?.['quantcast-consent']) {
            window.addEventListener('tcfLoaded', function () {
                dispatch(setTcfLoaded());
            });
        } else {
            dispatch(setTcfLoaded());
        }
        dispatch(initializeUiFromInitData(initData));
        dispatch(pushNotificationActions.init());
        dispatch(initLanguage(initData));
        const recentSearchesCookies = cookieUtil.readCookie(RECENT_SEARCHES);
        dispatch(initPersonalisation(recentSearchesCookies || ''));
        dispatch(initShippingRegion(initData));
        dispatch(initEnvironment(initData));
        dispatch(initMember(initData));
        dispatch(initInitData(initData));
        dispatch(
            initMultiCurrency({
                currencies,
                enabled: true,
                preferredCurrency
            })
        );
        dispatch(initializeItems(initData));
        dispatch(initializePage(initData));
        dispatch(initStartPage(initData));
        dispatch(fetchSystemMessages());
        dispatch(fetchSystemBadges());
        dispatch(discoverActions.initialize());
        dispatch(setRandomNumber());
        dispatch(initKountSessionId());
        dispatch(setOutageMessages(initData.outageFields));

        /**
         *  We hydrate the store with discover results from initData
         * this will be dispatched before any rendering to reduce the time from first byte to first render.
         */
        if (initData?.discoverResponse) {
            dispatch(
                receiveSearchResults({
                    endpoint: window.location.pathname,
                    queryParams: stripItmFromQueryParameters(
                        formatQueryParams(
                            toQueryParameters(window.location.search)
                        )
                    ),
                    result: initData.discoverResponse
                })
            );
        } else if (initData?.reportItem) {
            dispatch(handleReportItemModel(initData.reportItem));
        } else if (initData?.traderaShopProduct) {
            dispatch(handleTraderaShopProduct(initData.traderaShopProduct));
        }
    };
